/** important: do not change the value variable because of publisher usage */
export const MAIN_PLAYER_INSTANCE_KEY = 'MAIN';
export const INLINE_PLAYER_INSTANCE_KEY = 'INLINE';
export const VERTICAL_PLAYER_INSTANCE_KEY = 'VERTICAL';
export const INLINE_VERTICAL_PLAYER_INSTANCE_KEY = 'INLINE_VERTICAL';

// https://docs.videojs.com/player#readyState
export const HAVE_ENOUGH_DATA = 4;
